import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";

export const meta: ComponentMeta = {
  name: "Root",
  nameI18n: "builder_ui.block_type.root",
  version: 1,
  props: {
    children: {
      name: "Children",
      nameI18n: "builder_ui.prop_type.children",
      prop: "children",
      type: "children",
    },
  },
};
